import { __decorate, __metadata, __param } from 'tslib';
import { Directive, ElementRef, ChangeDetectorRef, Injectable, Pipe, Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateDirective, TranslateService, TranslatePipe, USE_DEFAULT_LANG, USE_STORE, USE_EXTEND, DEFAULT_LANGUAGE, TranslateStore, TranslateLoader, TranslateCompiler, TranslateParser, MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let UiBsTranslateDirective = class UiBsTranslateDirective extends TranslateDirective {
    constructor(uiBsTranslateService, uiBsElement, uiBsRef) {
        super(uiBsTranslateService, uiBsElement, uiBsRef);
        this.uiBsTranslateService = uiBsTranslateService;
        this.uiBsElement = uiBsElement;
        this.uiBsRef = uiBsRef;
    }
};
UiBsTranslateDirective = __decorate([
    Directive({
        selector: '[ui-translate]'
    }),
    __metadata("design:paramtypes", [TranslateService, ElementRef, ChangeDetectorRef])
], UiBsTranslateDirective);

let UiBsTranslatePepi = class UiBsTranslatePepi extends TranslatePipe {
    constructor(uiBsTranslate, uiBsUiRef) {
        super(uiBsTranslate, uiBsUiRef);
        this.uiBsTranslate = uiBsTranslate;
        this.uiBsUiRef = uiBsUiRef;
    }
};
UiBsTranslatePepi = __decorate([
    Injectable(),
    Pipe({
        name: 'wlpTranslate',
        pure: false // required to update the value when the promise is resolved
    }),
    __metadata("design:paramtypes", [TranslateService, ChangeDetectorRef])
], UiBsTranslatePepi);

let UiBsTranslateService = class UiBsTranslateService extends TranslateService {
    constructor(uiBsTranslateStore, uiBsTranslateLoader, uiBsTranslateCompiler, uiBsTranslateParser, uiBsMissingTranslationHandler, uiBsUseDefaultLang = true, uiBsIsolate = false, uiBsExtend = false, uiBsDefaultLanguage) {
        super(uiBsTranslateStore, uiBsTranslateLoader, uiBsTranslateCompiler, uiBsTranslateParser, uiBsMissingTranslationHandler, uiBsUseDefaultLang, uiBsIsolate, uiBsExtend, uiBsDefaultLanguage);
        this.uiBsTranslateStore = uiBsTranslateStore;
        this.uiBsTranslateLoader = uiBsTranslateLoader;
        this.uiBsTranslateCompiler = uiBsTranslateCompiler;
        this.uiBsTranslateParser = uiBsTranslateParser;
        this.uiBsMissingTranslationHandler = uiBsMissingTranslationHandler;
        this.uiBsUseDefaultLang = uiBsUseDefaultLang;
        this.uiBsIsolate = uiBsIsolate;
        this.uiBsExtend = uiBsExtend;
        if (uiBsDefaultLanguage) {
            this.setDefaultLang(uiBsDefaultLanguage);
            let layoutConfig = {};
            layoutConfig = JSON.parse(localStorage.getItem('layoutConfig'));
            if (!!layoutConfig)
                this.setDefaultLang(layoutConfig.wlTheme.languageDefault);
        }
        this.languageOptions = [
            { language: 'portuguese', text: 'Português', value: 'pt-br' },
            { language: 'english', text: 'English', value: 'en-us' },
            { language: 'chinese', text: '中文', value: 'zh' },
        ];
    }
    applyTranslate(key, interpolateParams) {
        let translated = '';
        this.get(key, interpolateParams).subscribe((response) => {
            translated = response;
        });
        return translated;
    }
    getFlag(language) {
        return '../assets/icon/' + language + '.svg';
    }
    getListLanguage() {
        return this.languageOptions;
    }
    setLanguage(language) {
        switch (language) {
            case 'en-us':
                return 'english';
            case 'pt-br':
                return 'portuguese';
            case 'zh':
                return 'chinese';
            case 'sp':
                return 'spanish';
            default:
                return 'portuguese';
        }
    }
};
UiBsTranslateService = __decorate([
    Injectable(),
    __param(5, Inject(USE_DEFAULT_LANG)),
    __param(6, Inject(USE_STORE)),
    __param(7, Inject(USE_EXTEND)),
    __param(8, Inject(DEFAULT_LANGUAGE)),
    __metadata("design:paramtypes", [TranslateStore,
        TranslateLoader,
        TranslateCompiler,
        TranslateParser,
        MissingTranslationHandler, Boolean, Boolean, Boolean, String])
], UiBsTranslateService);

var UiBsTranslateModule_1;
let UiBsTranslateModule = UiBsTranslateModule_1 = class UiBsTranslateModule {
    constructor(parentModule, translate) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsTranslateModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiBsTranslateModule = UiBsTranslateModule_1 = __decorate([
    NgModule({
        declarations: [UiBsTranslateDirective, UiBsTranslatePepi],
        imports: [
            TranslateModule.forRoot({
                defaultLanguage: localStorage.getItem('layoutConfig') != null ?
                    JSON.parse(localStorage.getItem('layoutConfig')).wlTheme.languageDefault : 'pt-br',
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient],
                },
            }),
        ],
        exports: [UiBsTranslateDirective, UiBsTranslatePepi],
        providers: [UiBsTranslateService],
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsTranslateModule, UiBsTranslateService])
], UiBsTranslateModule);
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}

export { HttpLoaderFactory, UiBsTranslateDirective, UiBsTranslateModule, UiBsTranslatePepi, UiBsTranslateService };
//# sourceMappingURL=wlp-ui-bs-translate.js.map
